import React, { Component } from "react";
import { connect } from "react-redux";

class Couple extends Component {
  render() {
    return (
      <div>
        <br />
        <center>
          <img
            src={"/get_couple/" + this.props.match.params.id}
            alt="doppelgangers"
          />
        </center>
      </div>
    );
  }
}

function mapStateToProps({ auth }) {
  return { auth };
}

export default connect(mapStateToProps)(Couple);



// WEBPACK FOOTER //
// ./src/components/Couple.js